import React from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "@mui/material";
import { useMutation } from "react-query";
import { setOrganizationIsReloAllowed } from "../../api/api";
import { Organization } from "../../types/api.types";
import { showToastError, showToastSuccess } from "common/toast/toast";
import { queryClient } from "../../modules/queryClient";

interface ReloOrganizationSettingsProps {
  organization: Organization;
}

export const ReloOrganizationSettings: React.FC<
  ReloOrganizationSettingsProps
> = ({ organization }) => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation(setOrganizationIsReloAllowed, {
    onSuccess: (data) => {
      queryClient.setQueryData<Organization | undefined>("organization", data);
      queryClient.invalidateQueries("organization");
      showToastSuccess(t("organizationSettings.reloAppraiser.updateSuccess"));
    },
    onError: () => {
      showToastError(t("organizationSettings.reloAppraiser.updateError"));
    },
  });

  const handleChange = () => {
    if (isLoading) return;
    mutate(!organization.isReloAllowed);
  };

  return (
    <Switch
      checked={!!organization.isReloAllowed}
      onChange={handleChange}
      disabled={isLoading}
      color="primary"
    />
  );
};
